import { FormikErrors } from 'formik';
import { intersection } from 'lodash/fp';

import { AGE_FIELD_ERROR_MESSAGES, LEAD_CAPTURE_FIELDS } from '../../../../data/constants';
import { HealthFormValues } from '../../../../types';
import getHasPartner from '../../../../utils/get-has-partner';

const getAgeSectionErrorMessage = (errors: FormikErrors<HealthFormValues> | null, scale: string) => {
  if (!errors) return undefined;
  const hasAgeError = 'age' in errors;
  const hasPartnerAgeError = getHasPartner(scale) && 'partnerAge' in errors;
  if (hasAgeError && hasPartnerAgeError) {
    return `${AGE_FIELD_ERROR_MESSAGES.AGE_AND_PARTNER_AGE} to continue.`;
  }
  if (hasAgeError) {
    return `${AGE_FIELD_ERROR_MESSAGES.AGE} to continue.`;
  }
  if (hasPartnerAgeError) {
    return `${AGE_FIELD_ERROR_MESSAGES.PARTNER_AGE} to continue.`;
  }

  // All optional non-age related lead capture fields can share a single error for simplicity
  const hasLeadCaptureError = intersection(Object.values(LEAD_CAPTURE_FIELDS), Object.keys(errors)).length > 0;
  if (hasLeadCaptureError) {
    return AGE_FIELD_ERROR_MESSAGES.LEAD_CAPTURE;
  }

  return undefined;
};

export default getAgeSectionErrorMessage;
